import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css'],
    standalone: false
})
export class NotFoundComponent implements OnInit {

  title: string;
  description: string;
  footerText: string;


  constructor(
    private route: ActivatedRoute,
  ) {
    route.queryParams.subscribe((queryParams) => {
    });
  }

  ngOnInit() {

  }

}
